import React from 'react';

import theme from 'shared/constants/theme.json';
import { FormattedMessage } from 'react-intl';
import globalMessages from 'translations/messages';
import ErrorBoundary from 'components/ErrorBoundary';
import { Modal as AntModal } from 'antd';
import './modal.less';

const Modal = ({
  open,
  children,
  width,
  fullWidth,
  cancelText = <FormattedMessage {...globalMessages.cancel} />,
  okText = <FormattedMessage {...globalMessages.ok} />,
  style = {},
  ...props
}) => (
  <AntModal open={open} width={fullWidth ? '90vw' : width} style={{ maxWidth: theme.desktopContentWidth, ...style }} cancelText={cancelText} okText={okText} {...props}>
    <ErrorBoundary reset={open}>
      {!!open && children}
    </ErrorBoundary>
  </AntModal>
);

export default Modal;
